import bugsnagClient from "@/lib/bugsnag";
import useStrapiStore from "@/store/useStrapi";

interface UserData {
  customer: {
    id: string;
    email: string;
    name?: string;
    phone?: string;
  };
  auth_token: string;
}

export const getUserFromStorage = (): UserData | null => {
  if (typeof window === "undefined") return null;

  const user = localStorage.getItem("@user");
  if (user) {
    try {
      const userParsed = JSON.parse(user) as {
        customer?: {
          id?: string;
          email?: string;
          name?: string;
          phone?: string;
        };
      };
      if (userParsed?.customer?.id) {
        bugsnagClient.setUser(
          `${userParsed.customer.id}`,
          `${userParsed.customer.email ?? ""}`,
          `${userParsed.customer.name ?? ""}`
        );
      }
    } catch {
      /* ignore malformed @user */
    }
  } else {
    const sessionId = localStorage.getItem("session_id");
    if (sessionId) bugsnagClient.setUser(`${sessionId}`);
  }

  const userStr = localStorage.getItem("@user");
  if (!userStr) return null;

  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

export const isAuthenticated = (): boolean => {
  if (typeof window === "undefined") return false;

  const user = getUserFromStorage();
  const token = localStorage.getItem("@auth_token");

  return !!(user && token);
};

export const getUserName = (): string | null => {
  if (typeof window === "undefined") return null;

  const user = getUserFromStorage();
  return user?.customer?.name || null;
};

export const getAuthToken = (): string | null => {
  if (typeof window === "undefined") return null;

  return localStorage.getItem("@auth_token");
};

// Funções para gerenciar o evento de mudança de estado do usuário
export const setupUserStateListener = (
  onUserStateChange: (userName: string | null) => void
): (() => void) => {
  if (typeof window === "undefined") return () => {};

  const handleUserStateChange = (event: CustomEvent) => {
    const userData = event.detail;
    if (userData?.customer?.name) {
      onUserStateChange(userData.customer.name);
    }
  };

  window.addEventListener(
    "userStateChanged",
    handleUserStateChange as EventListener
  );

  return () => {
    window.removeEventListener(
      "userStateChanged",
      handleUserStateChange as EventListener
    );
  };
};

export const forceLogout = (): void => {
  const { redirect_home_url } = useStrapiStore.getState();

  if (typeof window === "undefined") return;
  const target = redirect_home_url || "/";
  try {
    localStorage.clear();
    void import("@/services/api")
      .then(({ api }) => {
        delete api.defaults.headers.common["Authorization"];
        window.location.href = target;
      })
      .catch(() => {
        window.location.href = target;
      });
  } catch (error) {
    console.error("Erro ao limpar localStorage no forceLogout:", error);
    window.location.href = target;
  }
};
